<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-title>Calculadora de Medidas</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [scrollY]="false" class="ion-no-padding">

    <div class="layout-container">
        <!-- Fixed Top: Summary -->
        <div class="summary-section">
            <div class="total-label">Área Total</div>
            <div class="total-value">{{ totalArea | number:'1.2-2' }} <small>{{ unit }}</small></div>
        </div>

        <!-- Scrollable Middle: List -->
        <div class="details-list">
            <ion-list>
                <ion-item-sliding *ngFor="let item of details; let i = index">
                    <ion-item (click)="editDetail(i)" detail="true" button lines="full">
                        <ion-icon name="create-outline" slot="start" color="tertiary"></ion-icon>
                        <ion-label>
                            <h2>{{ item.descripcion }}</h2>
                            <p>{{ item.ancho }} x {{ item.alto }} {{ item.unidad }} = <strong>{{ item.area |
                                    number:'1.2-4' }} m²</strong></p>
                        </ion-label>
                        <ion-thumbnail slot="end" *ngIf="item.foto">
                            <img [src]="'data:image/jpeg;base64,' + item.foto" />
                        </ion-thumbnail>
                    </ion-item>
                    <ion-item-options side="end">
                        <ion-item-option color="danger" (click)="removeDetail(i)">
                            <ion-icon name="trash" slot="icon-only"></ion-icon>
                        </ion-item-option>
                    </ion-item-options>
                </ion-item-sliding>
            </ion-list>

            <div class="empty-msg" *ngIf="details.length === 0">
                <ion-icon name="cube-outline"></ion-icon>
                <p>Sin medidas</p>
            </div>
        </div>

        <!-- Fixed Bottom: Form -->
        <div class="add-form">
            <div class="form-header">Nueva Medida</div>
            <ion-grid class="ion-no-padding">
                <ion-row>
                    <ion-col size="12">
                        <ion-item class="compact-item">
                            <ion-input placeholder="Descripción (ej. Pared)"
                                [(ngModel)]="current.descripcion"></ion-input>
                        </ion-item>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="4">
                        <ion-item class="compact-item">
                            <ion-label position="stacked">Ancho</ion-label>
                            <ion-input type="number" [(ngModel)]="current.ancho"></ion-input>
                        </ion-item>
                    </ion-col>
                    <ion-col size="4">
                        <ion-item class="compact-item">
                            <ion-label position="stacked">Alto</ion-label>
                            <ion-input type="number" [(ngModel)]="current.alto"></ion-input>
                        </ion-item>
                    </ion-col>
                    <ion-col size="4">
                        <ion-item class="compact-item">
                            <ion-label position="stacked">Unidad</ion-label>
                            <ion-select [(ngModel)]="current.unidad" interface="popover">
                                <ion-select-option value="m">m</ion-select-option>
                                <ion-select-option value="cm">cm</ion-select-option>
                                <ion-select-option value="in">in (pulgadas)</ion-select-option>
                                <ion-select-option value="ft">ft (pies)</ion-select-option>
                            </ion-select>
                        </ion-item>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <div class="action-buttons">
                <ion-button size="small" fill="outline" (click)="takePhoto()">
                    <ion-icon name="camera" slot="icon-only"></ion-icon>
                </ion-button>
                <ion-button expand="block" (click)="addDetail()" [disabled]="!isValid()" class="add-btn">
                    <ion-icon name="add" slot="start"></ion-icon>
                    Agregar
                </ion-button>
            </div>
            <img *ngIf="current.foto" [src]="'data:image/jpeg;base64,' + current.foto" class="preview-mini"
                (click)="manageImage()" />
        </div>
    </div>

</ion-content>

<ion-footer>
    <ion-toolbar style="--background: transparent;">
        <ion-button expand="block" (click)="finish()" class="finish-btn">
            <ion-icon name="checkmark-done" slot="start"></ion-icon>
            Terminar y Calcular
        </ion-button>
    </ion-toolbar>
</ion-footer>
